var OCS = OCS || {};
var empty = function () {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.AjaxAbstractRequest = new Class({
    Implements: [Chain, Events, Options, Class.Thenable, new Class(OCS.Interfaces.UniqueId)],
    class_type: "Request",
    class_name: "AjaxAbstractRequest",
    id: null,
    failed_attempts: 0,
    storeCompletedReqTimeout: null,
    successful: false,
    bound_methods: {},
    options: {/*
     onRequest: function(){},
     onLoadstart: function(event, xhr){},
     onProgress: function(event, xhr){},
     onComplete: function(){},
     onCancel: function(){},
     onSuccess: function(responseText, responseXML){},
     onFailure: function(xhr){},
     onException: function(headerName, value){},
     onTimeout: function(){},
     user: '',
     password: '',*/
        url: '',
        url_keys: {},
        data: '',
        headers: {
            'Accept': 'text/javascript, text/html, application/xml, text/xml, */*'
        },
        async: true,
        format: false,
        method: 'post',
        link: 'ignore',
        isSuccess: null,
        emulation: true,
        urlEncoded: true,
        encoding: 'utf-8',
        evalScripts: false,
        evalResponse: false,
        corsRequest: true,
        timeout: 0,
        passthrough_ops: {},
        noCache: false,
        responseType: null,
        default_protocol: "https:",
        storeCompletedReq: 0 // 0 means to not delete the request. A value greater than 0 will result in the request being destroyed and removed after completion
    },
    initialize: function (options) {
        this.setOptions(options);
        this.id = this.create_unique_id();
        this.bound_methods.onComplete = this.onComplete.bind(this);
        this.addEvent('complete', this.bound_methods.onComplete);
    },
    check: function () {
        if (!this.running)
            return true;
        switch (this.options.link) {
            case 'cancel':
                this.cancel();
                return true;
            case 'chain':
                this.chain(this.caller.pass(arguments, this));
                return false;
        }
        return false;
    },
    url_string_replace: function (url_str) {
        Object.each(this.options.url_keys, function (value, key) {
            url_str = url_str.replace(new RegExp("{" + key + "}", 'g'), value);
        });
        // Clear any {key} that were not set
        url_str = url_str.replace(/{(?:\w)+}\/|{(?:\w)+}/g, '');
        this.options.url_keys = {};
        return url_str;
    },
    failure: function () {
        this.failed_attempts++;
        this.successful = false;
        this.onFailure();
        this.reject({reason: 'failure', xhr: this.xhr, response: this.response, request: this, failed_attempts: this.failed_attempts});
    },
    success: function (response) {
        response.request = this;
        if (response.text !== null || response.text !== undefined) {
            response.text = this.processScripts(response.text);
        }
        this.successful = true;
        this.onSuccess(response);
        this.resolve(response);
    },
    onSuccess: function () {
        this.fireEvent('complete', arguments).fireEvent('success', arguments).callChain();
    },
    onComplete: function() {
        if (this.options.storeCompletedReq) {
            if (this.options.noCache && !this.storeCompletedReqTimeout) {
                this.storeCompletedReqTimeout = setTimeout(this.destroy.bind(this), 0);
                return;
            }
            if (!this.storeCompletedReqTimeout) {
                this.storeCompletedReqTimeout = setTimeout(this.destroy.bind(this), this.options.storeCompletedReq);
                return;
            }
        }
    },
    onFailure: function () {
        this.fireEvent('complete').fireEvent('failure', {xhr: this.xhr, response: this.response, request: this, failed_attempts: this.failed_attempts});
    },
    loadstart: function (event) {
        this.fireEvent('loadstart', {event: event, xhr: this.xhr});
    },
    progress: function (event) {
        this.fireEvent('progress', {event: event, xhr: this.xhr});
    },
    timeout: function () {
        this.fireEvent('timeout', this.xhr);
        this.reject({reason: 'timeout', xhr: this.xhr});
        return this;
    },
    send: function (options) {

    },
    cancel: function () {

    },
    isSuccess: function () {
        var status = this.status;
        return (status >= 200 && status < 300);
    },

    isRunning: function () {
        return !!this.running;
    },
    get_passthrough_ops: function () {
        return this.options.passthrough_ops;
    },
    set_url_keys: function (url_keys) {
        this.options.url_keys = url_keys;
        return this;
    },
    destroy: function () {
        if(this.isRunning()) {
            this.cancel();
        }
        this.removeEvent('complete', this.bound_methods.onComplete);
        clearTimeout(this.storeCompletedReqTimeout);
        this.storeCompletedReqTimeout = null;
        this.fireEvent('destroy', this);
        this.removeEvents();
        this.$events = {};
        this.bound_methods = {};
        this.options = {};

    }
});
var methods = {};
['get', 'post', 'put', 'delete', 'patch', 'head', 'GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'HEAD'].each(function (method) {
    methods[method] = function (data) {
        var object = {
            method: method
        };
        if (data !== null && data !== undefined)
            object.data = data;
        return this.send(object);
    };
});

OCS.Classes.AjaxAbstractRequest.implement(methods);
